import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const BusinessPerformanceReview = () => {
  const serviceData = {
    title: "Business Performance Review",
    heading: "Business Performance Review",
    image: subTopicImages["Business Performance Review"],
    intro:
      "Understanding how your business is performing — not just financially, but operationally.",
    description: [
      "We help you understand how your business is performing — not just financially, but operationally. Our insights help you focus on what drives performance and where improvements matter most.",
    ],
    services: [
      {
        title: "Performance Review Components",
        text: "Our detailed review includes:",
        list: [
          "review of profitability, cost drivers & margins",
          "business unit / segment performance analysis",
          "trend analysis and benchmarking",
          "identification of improvement opportunities",
        ],
        extraInfo:
          "Our insights help you focus on what drives performance and where improvements matter most.",
      },
    ],
    benefitsIntro: "Key Benefits:",
    benefits: [
      "Operational & financial clarity",
      "Better understanding of cost drivers",
      "Benchmarking against industry standards",
      "Actionable improvement opportunities",
    ],
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default BusinessPerformanceReview;
